define('plugin/invoice/collection/InvoiceCollection',['require','lib/collection/ServerPaginatedCollection','plugin/invoice/model/InvoiceModel'],function (require) {

    var ServerPaginatedCollection = require('lib/collection/ServerPaginatedCollection');
    var InvoiceModel = require('plugin/invoice/model/InvoiceModel');

    /**
     * Invoice collection
     *
     * @class InvoiceModel
     */
    return ServerPaginatedCollection.extend({

        url: '/ext/invoice',
        model: InvoiceModel

    });

});
